import React from 'react'
import variables from '../../../theme/variables.scss'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import HolterPills from '../../holter-component/holter-pills'
const HolterInfo = () => {
    return (
        <>
            <Typography className="gray-600 fs-7 fw-normal pb-2 ">Holter</Typography>
            <Box
                sx={{
                    border: 1,
                    borderRadius: '0.25rem',
                    borderColor: variables.lightGray1,
                    overflow: 'hidden',
                }}
            >
                <div className="mt-3 ms-3 w-100">
                    <HolterPills name="dashboard-pills" time="" consultLetterFlag={true} />
                </div>
            </Box>
        </>
    )
}

export default HolterInfo
